import Vue from 'vue'
import axios from '@core_utils/api/_axios.js'
import i18n from '@/i18n'

const dashboard = {
    namespaced: true,
    state: {
        campaign_list: [],
        is_campaign_list_loaded: false,
        camp_id: 0,
        now_camp: {},
        risk_defs:[{risk:'high', name: '미흡'}, {risk:'mid', name: '양호'}, {risk:'low', name: '우수'}],
        cat2_risks: [
            // {
            //     "campaign_id": 186,
            //     "category1_name": "환경",
            //     "category1_name_e": "Environment",
            //     "category2_code": "enems",
            //     "category2_name": "환경경영시스템",
            //     "category2_name_e": "Environmental Management System",
            //     "question_description": "기업 및 조직은 사업 활동으로 인해 발생하는 부정적 환경 영향을 최소화하기 위해 적극적으로 노력해야 합니다. 환경정책을 수립하여 환경경영의 기본 원칙을 수립하고, 담당 조직 및 회의체를 중심으로 환경 현황 및 성과를 정기적으로 검토 및 개선하는 시스템을 갖춤으로써 환경 성과 관리의 기반을 마련할 수 있습니다.",
            //     "question_description_e": "Companies and organizations must actively strive to minimize the negative environmental impact of their business activities. By establishing environmental policies, basic principles of environmental management, and having a system to regularly review and improve environmental status and performance centered on the responsible organizations and meetings, a company can lay the foundation for environmental performance management.",
            //     "question_type": "core",
            //     "score": 58,
            //     "risk_lv": "mid",
            //     "weight_rate": 0.09
            // },
        ],
        cat3_names: [],
        is_cat3_name_loaded: false,
        total_score_obj: {},
        cat1_scores:[],
        is_cat1_score_loaded: false,
        compliance_issues: [],
        is_compliance_exist: false,
        camp_not_completed: false
    },
    mutations: {
        update_campaign_list(state, new_list){
            state.campaign_list = new_list
        },
        update_campaign_list_loaded(state, flag){
            state.is_campaign_list_loaded = flag
        },
        update_camp_id(state, new_id){
            state.camp_id = new_id
        },
        update_camp_not_completed(state, flag){
            state.camp_not_completed = flag
        },
        update_now_camp(state, new_camp){
            state.now_camp = new_camp
        },
        update_now_camp_and_camp_id(state, new_id){
            state.camp_id = new_id
            let temp_list = [...state.campaign_list]
            let idx = temp_list.findIndex(x => x.campaign_id == new_id)
            if(idx>-1){
                state.now_camp = temp_list[idx]
            }
        },
        update_cat2_risks(state, new_arr){
            state.cat2_risks = new_arr
        },
        update_score_category3_name(state, new_arr){
            state.cat3_names = new_arr
        },
        update_category3_name_loaded(state,flag){
            state.is_cat3_name_loaded = flag
        },
        update_total_score_obj(state, new_obj){
            state.total_score_obj = new_obj
        },
        update_cat1_scores(state, new_arr){
            state.cat1_scores = new_arr
        },
        update_is_cat1_score_loaded(state, flag){
            state.is_cat1_score_loaded = flag
        },
        update_compliance_issues(state, new_arr){
            state.compliance_issues = new_arr
        },
        update_compliance_exist(state, flag){
            state.is_compliance_exist = flag
        }, 
        set_temp_campaign(state, new_list){
            if (new_list[0].campaigns.length) {
                state.now_camp = new_list[0].campaigns[0]
                state.camp_id = new_list[0].campaigns[0].campaign_id
            }
        }
    },
    getters: {
        campaign_period_list(state){
            let new_arr = []
            if(state.campaign_list.length>0){
                for(let i=0; i<state.campaign_list.length; i++){
                    let obj = { value: state.campaign_list[i].campaign_id, text: state.campaign_list[i].requested_ts.substr(0,10) }
                    new_arr.push(obj)
                }
            }else {
                let obj = { value: null, text: i18n.t('아직 완료된 평가가 없습니다.') }
                new_arr.push(obj)
            }
            return new_arr
        },
        hashed_cat1_risks(state){
            let temp_obj = {}
            for (let i=0; i<state.cat2_risks.length; i++){
                if (temp_obj[state.cat2_risks[i].category1_name]){
                    temp_obj[state.cat2_risks[i].category1_name].push(state.cat2_risks[i])
                } else {
                    Vue.set(temp_obj, state.cat2_risks[i].category1_name, [state.cat2_risks[i]])
                }
            }     
            return temp_obj
        },
        hashed_cat1_scores(state){
            let temp_obj = {}
            for (let i=0; i<state.cat1_scores.length; i++){
                if (state.cat1_scores[i].category1_name){
                    temp_obj[state.cat1_scores[i].category1_name].push(state.cat1_scores[i])
                } else {
                    Vue.set(temp_obj, state.cat1_scores[i].category1_name, state.cat1_scores[i])
                }
            }     
            return temp_obj
        },

    },
    actions: {
        // async readCampaignsDashboard ({ commit }, user_id) {
        //     const response = await axios.get('/read_campaigns_dashboard', {
        //         params:{ user_id }
        //     })
        //     if (response.data.code === 'success') {
        //         commit('update_campaign_list', response.data.campaign_list)
        //         if (response.data.campaign_list && response.data.campaign_list.length > 0) {
        //             commit('update_camp_id', response.data.campaign_list[0].campaign_id)
        //         }
        //         commit('update_now_camp', response.data.campaign_list[0])
        //         commit('update_campaign_list_loaded', true)
        //     } else {
        //         commit('update_camp_not_completed', true)
        //     }
        // },
        async readCategory2Risklv ({ commit }, { company_id, campaign_id }) {
            const response = await axios.get('/read_category2_risklv', {
                params: { company_id, campaign_id }
            })
            if (response.data.code === 'success') {
                commit('update_cat2_risks', response.data.value)
            } else {
                console.log(response.data.msg);
            }  
        },
        async readScoreTotal({ commit }, { company_id, campaign_id }){
            const response = await axios.get('/read_score_total', {params: {company_id: company_id, campaign_id: campaign_id}})
            if (response.data.code === 'success') {
                commit('update_total_score_obj', response.data.value)
            } else{
                console.log(response.data.msg);
            } 
        },
        readScoreTotalBm({ rootState }, { company_id, campaign_id }){
            const path = rootState.backend_host + '/read_score_total_bm'
            return axios.get(path, {params: {company_id: company_id, campaign_id: campaign_id}})
            .then(response => {
                if(response.data.code == 'success'){
                    // console.log(response.data.value);
                    // commit('score_table_total_bm', response.data.value)
                }
                else{
                    console.log(response.data.msg);
                }
            })   
        },
        async readScoreCategories ({ commit }, { company_id, campaign_id }) {
            const response = await axios.get('/read_score_categories', {params: {company_id: company_id, campaign_id: campaign_id}})
            if (response.data.code === 'success') {
                commit('update_cat1_scores', response.data.value)
                commit('update_is_cat1_score_loaded', true)
            } else {
                console.log(response.data.msg);
            } 
        },
        readScoreCategoriesBm({ rootState }, { company_id, campaign_id }){
            const path = rootState.backend_host + '/read_score_categories_bm'
            return axios.get(path, {params: {company_id: company_id, campaign_id: campaign_id}})
            .then(response => {
                if(response.data.code == 'success'){
                    // console.log(response.data.value);
                    // commit('score_table_category1_bm', response.data.value)
                }
                else{
                    console.log(response.data.msg);
                }
            })   
        },
        async readScoreCategory3Name ({ commit }, {company_id, campaign_id}){
            const response = await axios.get('/read_score_category3_name', {
                params: { company_id, campaign_id}
            })
            if (response.data.code === 'success') {
                commit('update_score_category3_name', response.data.value)
                commit('update_category3_name_loaded', true)
            } else {
                console.log(response.data.msg);
            } 
        },
        async readComplianceIssues ({ commit }, { company_id, campaign_id }) {
            const response = await axios.get('/read_compliance_issues', {params:{company_id: company_id, campaign_id: campaign_id }})
            if (response.data.code === 'success') {
                commit('update_compliance_issues', response.data.value)
                commit('update_compliance_exist', true)
            } else if (response.data.code === 'not_exist') {
                commit('update_compliance_exist', false)
            } else {
                console.log(response.data);
            }
        }
    }
}

export default dashboard